"use strict";var r={ordersHistory:{"es-CO":{orderStatus:{FINISHED:{label:"ENTREGADO"}}}}};exports.default=r;